<template>

    <span @click='toggle' class="nav-link d-flex align-items-center">
        <span v-if='!darkMode' class="icon icon-moon text-bigger"></span>
        <span v-if='darkMode' class="icon icon-sun text-bigger"></span>
    </span>

</template>

<script>
    export default {

        mounted() {
            var dm = localStorage.getItem('_dm');

            if( dm ) {
                this.$nextTick( () => {
                   this.goDark(); 
                }) 
            }

        },

        created() {
        },

        data() {
            return {
                isReady : false,
                darkMode : false
            }
        },

        methods : {

            toggle() {

                if( this.darkMode ) {
                  
                   this.goLight();
              
                } else {
                
                   this.goDark();
                
                }

            },

            goLight() {
                $("body").removeClass("dark-mode");
                this.darkMode = false;

                localStorage.removeItem('_dm');
            },

            goDark() {
                $("body").addClass("dark-mode");
                this.darkMode = true;

                localStorage.setItem('_dm',1);
            }

        }

    }
</script>
